module.exports = __webpack_public_path__ + "img/cl_mobile_slogan.8af24dfb.png";